import { LogoTelegram } from "@gravity-ui/icons";
import { Button, Flex, Icon } from "@gravity-ui/uikit";
import Marquee from "react-fast-marquee";
import { POIZON_API_BOT_LINK } from "src/constants/links";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { T, useTranslate } from "src/i18n";

import { TextSection } from "../TextSection";
import { useReviews } from "./hooks/useReviews.ts";
import { ReviewCard } from "./ReviewCard/ReviewCard";
import css from "./ReviewsBlock.module.scss";

export const ReviewsBlock = () => {
  const { isMobile } = useGravityDevice();
  const { t } = useTranslate();
  const reviews = useReviews();

  return (
    <Flex
      id="reviews"
      direction={"column"}
      className={css.slideContainer}
      style={{ gap: 60 }}
    >
      <Flex
        direction={"column"}
        width={"100%"}
        maxWidth={"1440px"}
        style={{
          paddingLeft: isMobile ? 30 : 50,
          paddingRight: isMobile ? 30 : 50,
          gap: 60,
          margin: "0 auto",
        }}
      >
        <TextSection
          title={t("landing.reviews_block.title", "Отзывы")}
          description={t(
            "landing.reviews_block.description",
            "Что говорят о нас пользователи, больше 98% пользователей довольны сервисом и скоростью поддержки",
          )}
        />
      </Flex>
      <div className={css.cardsTopMargin}>
        {reviews.map((arr, ind) => {
          return (
            <div className={css.slideContainer} key={`review_div_${ind}`}>
              <Marquee speed={ind == 0 ? 20 : 30}>
                {arr.map((el, i) => (
                  <ReviewCard review={el} key={`review_${ind}_${i}`} />
                ))}
              </Marquee>
            </div>
          );
        })}
      </div>
      <Flex
        style={{
          paddingLeft: isMobile ? 30 : 50,
          paddingRight: isMobile ? 30 : 50,
        }}
      >
        <Button
          view="flat-info"
          href={POIZON_API_BOT_LINK}
          target="_blank"
          size="xl"
          selected
          width="max"
          style={{ maxWidth: isMobile ? "100%" : 300, margin: "0 auto" }}
        >
          <Icon data={LogoTelegram} />
          <T
            keyName={"landing.reviews_block.button"}
            defaultValue={"Оставить отзыв"}
          />
        </Button>
      </Flex>
    </Flex>
  );
};
